export default __webpack_public_path__ + "static/instructions-5edd9f567f2c590eba798e33e0457f74.gif";